/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/root/form-modal/form-modal.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../../public/upgrade/root/form-modal/form-modal.service';
import * as import10 from '../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import11 from '../../../../node_modules/@angular/forms/src/directives/ng_form.ngfactory';
import * as import12 from '../../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import13 from '@ngx-translate/core/src/translate.pipe';
import * as import14 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import15 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import16 from '@angular/core/src/linker/element_ref';
import * as import17 from '@ngx-translate/core/src/translate.service';
import * as import18 from '@angular/forms/src/directives/ng_form';
import * as import19 from '@angular/forms/src/directives/control_container';
import * as import20 from '@angular/forms/src/directives/ng_control_status';
import * as import21 from '@angular/common/src/directives/ng_class';
export class Wrapper_FormModalComponent {
  /*private*/ _eventHandler:Function;
  context:import0.FormModalComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  constructor(p0:any) {
    this._changed = false;
    this.context = new import0.FormModalComponent(p0);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  check_title(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.title = currValue;
      this._expr_0 = currValue;
    }
  }
  check_name(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.name = currValue;
      this._expr_1 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_FormModalComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_FormModalComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.FormModalComponent>;
  _FormModalComponent_0_3:Wrapper_FormModalComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_FormModalComponent_Host0,renderType_FormModalComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'form-modal',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_FormModalComponent0(this.viewUtils,this,0,this._el_0);
    this._FormModalComponent_0_3 = new Wrapper_FormModalComponent(this.injectorGet(import9.FormModalService,this.parentIndex));
    this.compView_0.create(this._FormModalComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._FormModalComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.FormModalComponent) && (0 === requestNodeIndex))) { return this._FormModalComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._FormModalComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  visitProjectableNodesInternal(nodeIndex:number,ngContentIndex:number,cb:any,ctx:any):void {
    if (((nodeIndex == 0) && (ngContentIndex == 0))) {  }
  }
}
export const FormModalComponentNgFactory:import8.ComponentFactory<import0.FormModalComponent> = new import8.ComponentFactory<import0.FormModalComponent>('form-modal',View_FormModalComponent_Host0,import0.FormModalComponent);
const styles_FormModalComponent:any[] = ([] as any[]);
var renderType_FormModalComponent:import4.RenderComponentType = import3.createRenderComponentType('',1,import5.ViewEncapsulation.None,styles_FormModalComponent,{});
export class View_FormModalComponent0 extends import2.AppView<import0.FormModalComponent> {
  _el_0:any;
  _NgClass_0_3:import10.Wrapper_NgClass;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  _NgForm_15_3:import11.Wrapper_NgForm;
  _ControlContainer_15_4:any;
  _NgControlStatusGroup_15_5:import12.Wrapper_NgControlStatusGroup;
  _text_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  _text_20:any;
  _map_25:any;
  /*private*/ _expr_26:any;
  _pipe_translate_0:import13.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_FormModalComponent0,renderType_FormModalComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._map_25 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-show-modal': p0};
    });
    this._expr_26 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray4(4,'class','eva-3-modal','style','z-index: 10'),(null as any));
    this._NgClass_0_3 = new import10.Wrapper_NgClass(this.parentView.injectorGet(import14.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import15.KeyValueDiffers,this.parentIndex),new import16.ElementRef(this._el_0),this.renderer);
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','modal-header'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'i',new import3.InlineArray2(2,'class','modal-close eva-3-icon-close'),(null as any));
    this._text_5 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','modal-title-container'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'h4',new import3.InlineArray2(2,'class','modal-title eva-3-h4 ng-scope'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_6,'\n        ',(null as any));
    this._text_11 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_12 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','modal-content eva-modal-container'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n        ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_13,'form',new import3.InlineArray2(2,'action',''),(null as any));
    this._NgForm_15_3 = new import11.Wrapper_NgForm((null as any),(null as any));
    this._ControlContainer_15_4 = this._NgForm_15_3.context;
    this._NgControlStatusGroup_15_5 = new import12.Wrapper_NgControlStatusGroup(this._ControlContainer_15_4);
    this._text_16 = this.renderer.createText(this._el_15,'\n            ',(null as any));
    this.projectNodes(this._el_15,0);
    this._text_17 = this.renderer.createText(this._el_15,'\n        ',(null as any));
    this._text_18 = this.renderer.createText(this._el_13,'\n    ',(null as any));
    this._text_19 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_20 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_0));
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_2));
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_4,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_4));
    this._pipe_translate_0 = new import13.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    var disposable_3:Function = import3.subscribeToRenderElement(this,this._el_13,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_13));
    var disposable_4:Function = import3.subscribeToRenderElement(this,this._el_15,new import3.InlineArray4(4,'submit',(null as any),'reset',(null as any)),this.eventHandler(this.handleEvent_15));
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._text_18,
      this._text_19,
      this._text_20
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import18.NgForm) && ((15 <= requestNodeIndex) && (requestNodeIndex <= 17)))) { return this._NgForm_15_3.context; }
    if (((token === import19.ControlContainer) && ((15 <= requestNodeIndex) && (requestNodeIndex <= 17)))) { return this._ControlContainer_15_4; }
    if (((token === import20.NgControlStatusGroup) && ((15 <= requestNodeIndex) && (requestNodeIndex <= 17)))) { return this._NgControlStatusGroup_15_5.context; }
    if (((token === import21.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 19)))) { return this._NgClass_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_0_0_0:any = 'eva-3-modal';
    this._NgClass_0_3.check_klass(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = this._map_25(this.context.getFormModal().getFormModal(this.context.name));
    this._NgClass_0_3.check_ngClass(currVal_0_0_1,throwOnChange,false);
    this._NgClass_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this._NgForm_15_3.ngDoCheck(this,this._el_15,throwOnChange);
    this._NgControlStatusGroup_15_5.ngDoCheck(this,this._el_15,throwOnChange);
    valUnwrapper.reset();
    const currVal_26:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(this.context.title)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_26,currVal_26))) {
      this.renderer.setText(this._text_9,currVal_26);
      this._expr_26 = currVal_26;
    }
    this._NgControlStatusGroup_15_5.checkHost(this,this,this._el_15,throwOnChange);
  }
  destroyInternal():void {
    this._NgForm_15_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      $event.stopPropagation();
      const pd_sub_0:any = ((<any>this.context.getFormModal().hideFormModal(true)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      $event.stopPropagation();
      const pd_sub_0:any = ((<any>this.context.getFormModal().hideFormModal(true)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_4(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.getFormModal().hideFormModal(true)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_13(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>$event.stopPropagation()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_15(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._NgForm_15_3.handleEvent(eventName,$event) && result);
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/root/form-modal/form-modal.component.ngfactory.ts